const hasTaskGroup = (taskGroup) => {
  return {
    taskGroup: Object.assign({ ...taskGroup }),
  };
};

export default hasTaskGroup;
